import EntityListManager from './EntityListManager';
import {
  getLeadStatuses,
  createLeadStatus,
  updateLeadStatus,
  deleteLeadStatus,
  reorderLeadStatuses,
} from '../../services/leadService';

const EXTRA_FIELDS = [
  {
    key: 'is_closed',
    label: 'Closed (archived)',
    description: 'Hidden from the active lead list and pipeline columns; counts toward Won/Lost reporting.',
  },
  {
    key: 'is_won',
    label: 'Triggers the Won flow',
    description: 'Moving a lead here opens the "mark as Won" form and creates a project.',
  },
  {
    key: 'is_lost',
    label: 'Triggers the Lost flow',
    description: 'Moving a lead here requires picking a reason.',
  },
];

export default function LeadStatusManager({ onMessage }) {
  return (
    <EntityListManager
      onMessage={onMessage}
      title="Lead Statuses"
      description="Manage the pipeline stages leads move through — which ones count as open, and which trigger the Won/Lost flows."
      entityNoun="Status"
      entityNounPlural="Statuses"
      idKey="status_id"
      namePlaceholder="e.g. Open, Quoted, Negotiating"
      load={() => getLeadStatuses().then((d) => d.statuses)}
      create={createLeadStatus}
      update={updateLeadStatus}
      remove={deleteLeadStatus}
      reorder={(ids) => reorderLeadStatuses(ids).then((d) => d.statuses)}
      protectDefaultRename
      protectDefaultDelete
      extraFields={EXTRA_FIELDS}
      deleteWarning={(item) => `Are you sure you want to delete the "${item.name}" status? Leads using this status will be moved to the first available status.`}
    />
  );
}
